module.exports = __webpack_public_path__ + "./images/1ba97f02b8c7cd2c1b066265130c4985.webp";